import React, { useEffect, useState } from "react";
import "./wpConfirmationTable.scss";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import countries_List from "../../Constants/country_list.json";
import state_List from "../../Constants/state_list.json";
import {
  docType,
  guestType,
  Italy_Country_Code,
} from "../../Constants/Constants";
import { toast } from "react-toastify";
import AllServices from "../../Services/AllServices";
import { useNavigate, useLocation } from "react-router-dom";
import CustomLoaderBoxy from "../CustomLoader/CustomLoaderBoxy";
import Swal from "sweetalert2";

const mergeCountriesAndCities = [...countries_List, ...state_List];

const WpConfirmationTable = ({ data, onClose }) => {
  const referenceNumber = data?.mainGuest?.refNumber;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const citizenCode = data.mainGuest.citizen;
  const citizen = countries_List.find(
    (item) => item.code === String(citizenCode),
  );
  const citizenName = citizen.country;

  const birthPlaceCode = data?.mainGuest?.placeOfBirth;

  const birthPlace = mergeCountriesAndCities.find(
    (item) => item.code === String(birthPlaceCode),
  );
  let birthPlaceName = birthPlace.country;

  const docTypeCode = data?.mainGuest?.docType;
  const documet = docType.find((item) => item.ID === docTypeCode);
  const docTypeName = documet.name;

  const guestTypeCode = data?.mainGuest?.famType;
  const guest = guestType.find((item) => item.ID === guestTypeCode);
  const guestTypeName = guest.name;

  const docIssuingCountryCode = data?.mainGuest?.docIssuingPlace;

  const docIssuingCountry = mergeCountriesAndCities.find(
    (item) => item.code === String(docIssuingCountryCode),
  );
  let docIssuingCountryName = docIssuingCountry.country;

  // }

  // For the child guest
  const childDocIssuingCode = data?.childGuest?.map(
    (child) => String(child.placeOfBirth) || [],
  );

  const list = citizen === Italy_Country_Code ? state_List : countries_List;

  const matchCountries = list.filter((item) =>
    (childDocIssuingCode || []).includes(item.code),
  );

  const childDocIssuingCountryNames = matchCountries.map(
    (item) => item.country,
  );

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      setLoading(true);
      const response = await AllServices.passdataWebPortal(data);
      if (response?.data?.succuss) {
        toast.success(response.data.message);
        // const date = "2026-01-04";
        // await handleViewPDF(date);
        // navigate("/admin/views/currentguest", {
        //   state: {
        //     open: true,
        //     referenceNumber: referenceNumber,
        //     date: new Date(Date() + "UTC"),
        //   },
        // });
        navigate("/adminuser/views/currentguest");
        onClose();
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  // const handleViewPDF = async (date) => {
  //   try {
  //     const response = await AllServices.getRecipt({ date });
  //     const soapXML = response.data.message;
  //     const parser = new DOMParser();
  //     const xmlDoc = parser.parseFromString(soapXML, "text/xml");
  //     const pdfNode = xmlDoc.getElementsByTagName("PDF")[0];

  //     if (!pdfNode) {
  //       toast.error("PDF not found in response");
  //       return;
  //     }

  //     const pdfBase64 = pdfNode.textContent;
  //     const byteCharacters = atob(pdfBase64);
  //     const byteNumbers = new Array(byteCharacters.length);

  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }

  //     const byteArray = new Uint8Array(byteNumbers);
  //     const blob = new Blob([byteArray], { type: "application/pdf" });
  //     const filename = `receipt_${date.replace(/-/g, "_")}.pdf`;

  //     // Auto download
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = filename;
  //     link.style.display = "none";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     // Also open in new tab
  //     window.open(url, "_blank");

  //     // Clean up
  //     setTimeout(() => URL.revokeObjectURL(url), 100);
  //   } catch (error) {
  //     toast.error(error.message || "Something went wrong");
  //   }
  // };

  return (
    <div className="wrapper-confirmation">
      {loading && (
        <div className="loader-overlay">
          <CustomLoaderBoxy />
        </div>
      )}

      <div className="view-details-containor">
        <div className="txtContainor">
          <span>Guest Type : {guestTypeName}</span>
          <span>Permanenza : {data.mainGuest.stayDays}</span>
        </div>

        <div className="middle">
          <TableContainer component={Paper} className="table-containor">
            <Table
              sx={{
                minWidth: 650,
                backgroundColor: "rgba(255, 251, 222, 0.5)",
              }}
              aria-label="simple table"
            >
              <TableHead className="table-head">
                <TableRow>
                  <TableCell className="table-cell">Cognome</TableCell>
                  <TableCell className="table-cell">Nome</TableCell>
                  <TableCell className="table-cell">Sesso</TableCell>
                  <TableCell className="table-cell">Data di Nascita</TableCell>
                  <TableCell className="table-cell">Cittadinanza</TableCell>
                  <TableCell className="table-cell">Luogo di Nascita</TableCell>
                  <TableCell className="table-cell">
                    Luogo di Rilascio Documento
                  </TableCell>
                  <TableCell className="table-cell">Typo Documento</TableCell>

                  <TableCell className="table-cell">Numero Documento</TableCell>
                </TableRow>
              </TableHead>

              <TableBody className="table-body">
                {data?.mainGuest ? (
                  <TableRow
                    sx={{
                      backgroundColor: "rgba(221, 246, 210, 0.5)",
                    }}
                  >
                    <TableCell className="table-cell">
                      {data.mainGuest.firstName}
                    </TableCell>
                    <TableCell className="table-cell">
                      {data.mainGuest.lastName}
                    </TableCell>
                    <TableCell className="table-cell">
                      {data.mainGuest.sex}
                    </TableCell>
                    <TableCell className="table-cell">
                      {data.mainGuest.dob
                        ? data.mainGuest.dob.split("T")[0]
                        : ""}
                    </TableCell>
                    <TableCell className="table-cell">{citizenName}</TableCell>
                    <TableCell className="table-cell">
                      {birthPlaceName}
                    </TableCell>
                    <TableCell className="table-cell">
                      {docIssuingCountryName}
                    </TableCell>
                    <TableCell className="table-cell">{docTypeName}</TableCell>
                    <TableCell className="table-cell">
                      {data.mainGuest.NumberDoc}
                    </TableCell>
                  </TableRow>
                ) : null}

                {data?.childGuest && data.childGuest.length > 0 ? (
                  data.childGuest.map((child) => (
                    <TableRow key={child.ID}>
                      {/* <TableCell className="table-cell">--</TableCell> */}
                      <TableCell className="table-cell">
                        {child.Fname}
                      </TableCell>
                      <TableCell className="table-cell">
                        {child.Lname}
                      </TableCell>
                      <TableCell className="table-cell">
                        {child.Gender}
                      </TableCell>
                      <TableCell className="table-cell">
                        {child.DOB ? child.DOB.split("T")[0] : ""}
                      </TableCell>
                      <TableCell className="table-cell">
                        {child.citizenQuery}
                      </TableCell>
                      <TableCell className="table-cell">
                        {child.birthPlaceQuery}
                      </TableCell>

                      <TableCell className="table-cell">--</TableCell>
                      <TableCell className="table-cell">--</TableCell>
                      <TableCell className="table-cell">--</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      No more data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="button-group">
          <button className="btn btn-blue" onClick={handleClick}>
            Invia Tutto
          </button>
          <button className="btn btn-red" onClick={onClose}>
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
};

export default WpConfirmationTable;
